import Routes from "@navigations/Routes";
import { navigate } from "@navigations/utils/RootNavigation";
import { setProductType } from "@redux/slices/appStateSlice";
import { setSectionName } from "@redux/slices/searchFilters";
import { Diamond } from "@src/types/DiamondDetail";
import { getProductPrefix, ProductCategory } from "@utils/constants";
import { SearchResultsAndFavoritesEnum } from "@utils/product/searchResultConstants";
import { getSectionName } from "@utils/product/searchResultsNavigation";

export enum FavoritesEnum {
  rename_collection = "rename_collection",
  create_new_collection = "create_new_collection",
  delete_collection = "delete_collection",
  collection = "collection",
  favorites_tag = "favorites",
  collection_name = "collectionName",
  move = "move",
  add_favorites = "add_favorites",
  bulk_request = "bulk_request",
  full_list = "FULL_LIST",
}

export const add_favorites = "add_favorites";

export const collectionMenuOptions = (t: any) => {
  return [
    {
      name: FavoritesEnum.rename_collection,
      label: t("favorites.renameCollection.text"),
    },
    {
      name: FavoritesEnum.delete_collection,
      label: t("favorites.deleteCollection.text"),
    },
  ];
};

export const shareMenuOptionsForFavoritesBulkActions = (t: any) => {
  return [
    {
      name: SearchResultsAndFavoritesEnum.SHARE_EMAIL,
      label: t("favoritesList.bulkActions.share.email.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.SHARE_NATIVE,
      label: t("favoritesList.bulkActions.share.native.text"),
    },
  ];
};

export const shareMenuOptions = (t: any) => {
  return [
    {
      name: SearchResultsAndFavoritesEnum.SHARE_EMAIL,
      label: t("favorites.shareMenu.email.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.SHARE_NATIVE,
      label: t("favorites.shareMenu.native.text"),
    },
  ];
};

export class SectionListObject {
  product_name: string;
  product_type: ProductCategory;
  data: Array<Diamond>;
  order: number;
  hideLoadMore: boolean;

  constructor(
    productName: string,
    productType: ProductCategory,
    dataArray: Array<Diamond>,
    mOrder: number,
    hideLoadMore: boolean
  ) {
    this.product_name = productName;
    this.product_type = productType;
    this.data = dataArray;
    this.order = mOrder;
    this.hideLoadMore = hideLoadMore;
  }
}

export type FavoriteType =
  | "mix"
  | "diamond"
  | "lab_grown_diamond"
  | "jewelry"
  | "gemstone"
  | "lab_grown_jewelry";

export const BulkActions = (t: any) => {
  return [
    {
      name: SearchResultsAndFavoritesEnum.MOVE_TO_ANOTHER_COLLECTION,
      label: t("favoritesList.bulkActions.moveToAnotherCollection.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.REMOVE_FROM_COLLECTION,
      label: t("favoritesList.bulkActions.removeFromCollection.text"),
    },
  ];
};

export const FavoriteBulkActions = (t: any) => {
  return [
    {
      name: SearchResultsAndFavoritesEnum.MOVE_TO_A_COLLECTION,
      label: t("favoritesList.bulkActions.moveToCollection.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.REMOVE_FROM_FAVORITES,
      label: t("favoritesList.bulkActions.removeFromFavorites.text"),
    },
  ];
};

export const initialProductArray = (t: any) => {
  return [
    {
      id: 1,
      title: t("favoritesList.screenOptions.changeView.text"),
      description: "Description for Change View",
      icon: SearchResultsAndFavoritesEnum.GRID,
      eventName: SearchResultsAndFavoritesEnum.CHANGE_VIEW,
      selection: true,
    },
  ];
};

export const FavoriteCollectionDefaultMenuItems = (t: any) => {
  return [
    {
      name: SearchResultsAndFavoritesEnum.VIEW_DETAILS,
      label: t("favoritesList.threeDotOptions.viewDetails.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.SHARE_EMAIL,
      label: t("favoritesList.threeDotOptions.share.email.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.SHARE_NATIVE,
      label: t("favoritesList.threeDotOptions.share.native.text"),
    },
  ];
};

export const ChangeViewMenuOptions = (t: any) => {
  return [
    {
      name: SearchResultsAndFavoritesEnum.GRID,
      label: t("favoritesList.changeViewOptions.gridView.text"),
      icon: SearchResultsAndFavoritesEnum.GRID,
    },
    {
      name: SearchResultsAndFavoritesEnum.VIDEO_ONLY,
      label: t("favoritesList.changeViewOptions.videoOnly.text"),
      icon: "video",
    },
  ];
};

export const MenuItemOptions = (t: any) => {
  return [
    {
      name: SearchResultsAndFavoritesEnum.MOVE_TO_ANOTHER_COLLECTION,
      label: t("favoritesList.threeDotOptions.moveToAnotherCollection.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.REMOVE_FROM_COLLECTION,
      label: t("favoritesList.threeDotOptions.removeFromCollection.text"),
    },
  ];
};

export const FavoritesMenuItemOptions = (t: any) => {
  return [
    {
      name: SearchResultsAndFavoritesEnum.MOVE_TO_A_COLLECTION,
      label: t("favoritesList.threeDotOptions.moveToCollection.text"),
    },
    {
      name: SearchResultsAndFavoritesEnum.REMOVE_FROM_FAVORITES,
      label: t("favoritesList.threeDotOptions.removeFromFavorites.text"),
    },
  ];
};

export const getProductIcon = (productType: string) => {
  switch (productType) {
    case ProductCategory.DIAMOND:
      return "upd-diamonds";
    case ProductCategory.GEMSTONE:
      return "upd-gemstones";
    case ProductCategory.JEWELRY:
      return "upd-jewelry";
    case ProductCategory.LABGROWN_JEWELRY:
      return "upd-lab-Jewelry";
    default:
      return "upd-lab-grown";
  }
};

export const getProductIconColor = (productType: string) => {
  switch (productType) {
    case ProductCategory.DIAMOND:
      return "diam-06";
    case ProductCategory.GEMSTONE:
      return "gem-06";
    case ProductCategory.JEWELRY:
      return "jewelry-06";
    case ProductCategory.LABGROWN_JEWELRY:
      return "jewelry-06";
    case ProductCategory.LAB_GROWN_DIAMOND:
      return "lab-06";
    case ProductCategory.LABGROWN_JEWELRY:
      return "jewelry-06";
    default:
      return "core-06";
  }
};

export const removeFromFavoritesSectionList = (
  sectionListData: SectionListObject[],
  itemIds: Array<number>
) => {
  return sectionListData.map((sectionObject) => {
    const mData = sectionObject.data.filter(
      (_item) => !itemIds.includes(_item?.fav_id ?? 0)
    );
    return { ...sectionObject, data: mData };
  });
};

export const removeFromFavoritesProductList = (
  mList: Diamond[],
  itemIds: Array<number>,
  applySelectedFilter: boolean
) => {
  let filteredList = mList.filter(
    (itemX) => !itemIds.includes(itemX?.fav_id ?? 0)
  );

  if (applySelectedFilter) {
    filteredList = filteredList.map((itemX) => ({
      ...itemX,
      is_selected: true,
    }));
  }

  return filteredList;
};

export const removeFromCollectionSectionList = (
  sectionListData: SectionListObject[],
  itemIds: Array<number>
) => {
  return sectionListData.map((sectionObject) => {
    const mData = sectionObject.data.filter(
      (_item) => !itemIds.includes(_item?.id ?? 0)
    );
    return { ...sectionObject, data: mData };
  });
};

export const removeFromCollectionProductList = (
  mList: Diamond[],
  itemIds: Array<number>,
  applySelectedFilter: boolean
) => {
  let filteredList = mList.filter((itemX) => !itemIds.includes(itemX?.id ?? 0));

  if (applySelectedFilter) {
    filteredList = filteredList.map((itemX) => ({
      ...itemX,
      is_selected: true,
    }));
  }

  return filteredList;
};

export const CollectionItemOptions = (
  t: any,
  showBulkRequest: boolean,
  inCart: boolean,
  menuOptions: any
) => {
  const combinedOptions =
    menuOptions?.length > 0
      ? [...menuOptions, ...MenuItemOptions(t)]
      : MenuItemOptions(t);
  const filteredOptions = combinedOptions.filter((option) => {
    const isExcludingBulkRequest = showBulkRequest
      ? inCart
        ? option.name !== SearchResultsAndFavoritesEnum.ADD_TO_BULK_REQUEST
        : option.name !== SearchResultsAndFavoritesEnum.REMOVE_FROM_BULK_REQUEST
      : option.name !== SearchResultsAndFavoritesEnum.ADD_TO_BULK_REQUEST &&
        option.name !== SearchResultsAndFavoritesEnum.REMOVE_FROM_BULK_REQUEST;

    return isExcludingBulkRequest;
  });
  return filteredOptions;
};

export const FavoriteOptions = (
  t: any,
  showBulkRequest: boolean,
  inCart: boolean,
  menuOptions: any
) => {
  const combinedOptions =
    menuOptions?.length > 0
      ? [...menuOptions, ...FavoritesMenuItemOptions(t)]
      : FavoritesMenuItemOptions(t);
  const filteredOptions = combinedOptions.filter((option) => {
    const isExcludingBulkRequest = showBulkRequest
      ? inCart
        ? option.name !== SearchResultsAndFavoritesEnum.ADD_TO_BULK_REQUEST
        : option.name !== SearchResultsAndFavoritesEnum.REMOVE_FROM_BULK_REQUEST
      : option.name !== SearchResultsAndFavoritesEnum.ADD_TO_BULK_REQUEST &&
        option.name !== SearchResultsAndFavoritesEnum.REMOVE_FROM_BULK_REQUEST;

    return isExcludingBulkRequest;
  });

  return filteredOptions;
};

function toTitleCase(str: string) {
  return str.toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
}

export function transformValue(value: any) {
  if (value && typeof value === "object" && "selected_slugs" in value) {
    return {
      ...value,
      selected_slugs: value.selected_slugs.map((v: any) => {
        if (typeof v === "string") {
          const words = v.split(" ");
          if (words.length === 3) {
            return [
              toTitleCase(words[0]), // first word
              words[1], // middle unchanged
              toTitleCase(words[2]), // last word
            ].join(" ");
          }
          return toTitleCase(v);
        }
        return v;
      }),
    };
  }
  return value;
}

export const fallbackIfEmptyDeeplink = (
  userInfo: any,
  dispatch: any,
  theme: any,
  productType?: string
) => {
  const defaultStockItem = userInfo?.defaultStockItemType();
  const allowedStockItem = userInfo?.getAllowedStockTypes();
  if (productType) {
    goToSearchResult(productType, dispatch, theme);
  } else if (allowedStockItem?.length === 1) {
    goToSearchResult(allowedStockItem[0], dispatch, theme);
  } else if (allowedStockItem?.length > 1) {
    goToSearchResult(defaultStockItem, dispatch, theme);
  }
};

const goToSearchResult = (mProductType: string, dispatch: any, theme: any) => {
  const filterSplitStep = 2;
  const sectionName = getSectionName(mProductType);
  dispatch(setProductType(mProductType));
  dispatch(setSectionName(sectionName));
  navigate(Routes.AppNavigator, {
    screen: Routes.ExploreNavigator,
    params: {
      screen: !theme.isMobile
        ? Routes.FilterSplitScreen
        : Routes.SearchResultScreen,
      initial: false,
      params: {
        productType: mProductType,
        sectionName,
        filterSplitStep,
        fromNewFilterScreen: false,
        productPrefix: getProductPrefix(mProductType),
      },
    },
  });
};

// const goToHomePage = () => {
//   navigate(Routes.HomeNavigator, {
//     screen: Routes.HomeScreen,
//   });
// };

// export const getUpdatedSectionList = (
//   sectionListData: SectionListObject[],
//   itemIds: Array<number>,
//   addToCart: boolean
// ) => {
//   const updatedSectionList = sectionListData.map((sectionObject) => {
//     const mData = sectionObject.data.map((_item) => {
//       if (_item?.id && itemIds.includes(_item?.id)) {
//         return { ..._item, in_cart: addToCart };
//       }
//       return _item;
//     });
//     return { ...sectionObject, data: mData };
//   });
//   return updatedSectionList;
// };

// export const getUpdatedStoneList = (
//   stoneList: Array<Diamond>,
//   itemIds: Array<Number>,
//   addToCart: boolean
// ) => {
//   const mList = stoneList.map((_item) => {
//     if (_item?.id && itemIds.includes(_item?.id)) {
//       return { ..._item, in_cart: addToCart };
//     }
//     return _item;
//   });
//   return mList;
// };
